import { useCallback, useMemo } from 'react';
import { useRouter } from 'next/router';

export const useUrlSku = (): [string | undefined, (sku: string) => void] => {
  const { replace, asPath } = useRouter();
  //it uses asPath instead of query from useRouter to avoid page shifting. query is not updated until the page is fully loaded
  const [pathname, queryString] = asPath.split('?');

  const urlParams = useMemo(() => new URLSearchParams(queryString), [queryString]);
  const sku = urlParams.get('sku') || '';

  const updateSkuInUrl = useCallback(
    (newSku: string): void => {
      urlParams.set('sku', newSku);

      if (sku !== newSku) {
        replace({ pathname, query: urlParams.toString() }, undefined, {
          shallow: true,
        }).catch(console.error);
      }
    },
    [replace, pathname, urlParams, sku]
  );
  return [sku, updateSkuInUrl];
};
